import {
  NavigateOptions,
  createSearchParams,
  useNavigate
} from "react-router-dom"

import merge from "lodash-es/merge"

import { useEvent } from "shared/lib/useEvent"
import { useLocale } from "shared/lib/useLocale"

export function useNavigateToItem<T extends string | null>(
  id: T,
  path: string,
  options?: NavigateOptions | undefined
): T extends string
  ? () => void
  : (payload?: {
      id: string
      params?: Record<string, string> | null
      options?: NavigateOptions | undefined
    }) => void
export function useNavigateToItem<T extends string | null>(
  id: T,
  path: string,
  options?: NavigateOptions | undefined
) {
  const navigate = useNavigate()
  const { currentLocale } = useLocale()

  return useEvent(
    (payload?: {
      id: string
      params?: Record<string, string> | null
      options?: NavigateOptions | undefined
    }) => {
      const resolvedID = id || payload?.id
      const pathname = `/${currentLocale}/${path}/${resolvedID}`
      if (payload?.params) {
        navigate(
          {
            pathname,
            search: `?${createSearchParams(payload.params)}`
          },
          merge({}, options, payload.options)
        )
      } else {
        navigate({ pathname }, merge({}, options, payload?.options))
      }
    }
  )
}
